<template>
  <ModalLocked @close="onModalClose" openOnInit="true" />
</template>

<script setup lang="ts">
import ModalLocked from "../components/Locked/ModalLocked.vue";
import { Flow, ScreenName } from "@spike/app2-sitemap/src/auth.js";
import { onMounted } from "vue";
import * as Nav from "../navigation";

onMounted(async () => {
  // console.log("onMounted:", ScreenRoute.Locked);
  Nav.startFlow(Flow.locked);
});

function onModalClose() {
  Nav.complete(ScreenName.Locked);
  location.href = "/";
}
</script>
